export default __webpack_public_path__ + "static/media/clock-icon.fdd3fa74.svg";